import script from "./InfoSessionFullyBookedComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./InfoSessionFullyBookedComponent.vue?vue&type=script&setup=true&lang=js"

import "./InfoSessionFullyBookedComponent.vue?vue&type=style&index=0&id=52e019d2&scoped=true&lang=css"

import exportComponent from "/home/forge/princes-trust.ac.uk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52e019d2"]])

export default __exports__